document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.getElementById('load-more');
    const posts = document.querySelectorAll('#post-list .post-item');
    let currentIndex = 12;
    const increment = 3;


    function loadMorePosts() {
        let count = 0;

        // Afficher les articles
        for (let i = currentIndex; i < posts.length && count < increment; i++) {
            posts[i].classList.remove('d-none');
            posts[i].classList.add('d-block');
            count++;
        }

        currentIndex += count;


        if (currentIndex >= posts.length) {
            loadMoreButton.classList.add('d-none');
        }
    }

    if (loadMoreButton && posts.length > 0) {
        loadMoreButton.addEventListener('click', loadMorePosts);
    }
});
